import Header from "./Header";
import Footer from "./Footer";
import { MobileActionBar, useShowBar } from "./MobileActionBar";
import { SimranChat } from "@/components/simran/SimranChat";
import { SwetaHelpDesk } from "@/components/SwetaHelpDesk";

export default function Layout({ children }) {
  const bar = useShowBar();
  return (
    <div className={`min-h-screen flex flex-col ${bar ? "pb-[calc(4.5rem+env(safe-area-inset-bottom))] md:pb-0" : ""}`}>
      <Header />
      <main className="flex-1">{children}</main>
      <Footer />
      <MobileActionBar />
      <SimranChat />
      <SwetaHelpDesk />
    </div>
  );
}
